import { version } from '@algolia/autocomplete-shared';
export var userAgents = [{
  segment: 'autocomplete-js',
  version: version
}];